// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-common-HeaderTab-HeaderTab-module__container-bwFLhC"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-common-HeaderTab-HeaderTab-module__container-bwFLhC\"}";
        // 1789362522805
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  